import Vue from 'vue'
import VueRouter from 'vue-router'
import $common from '../util/common.js'
import $userInfo from '../util/userInfo.js'

// import Index from '../views/Index.vue'
import IndexNew from '../views/IndexNew.vue'


Vue.use(VueRouter)


const routes = [
	// {
	// 	path: '/index',
	// 	name: 'Index',
	// 	component: Index,
	// 	meta:{
	// 		keepAlive: true
	// 	}
	// },
	// 登录
	{
		path: '/IndexNew',
		name: 'Login',
		component: IndexNew,
	},

	{
		path: '*',
		redirect: '/IndexNew'
	}
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

//  进入路由前钩子函数
router.beforeEach((to, from, next) => {
   	if(to.path=='/IndexNew' ){
   		//如果是登录页面路径，就直接next()
   		next();
   	} else {
   		 // 联合登录-地址栏获取ATOKEN
		if(to.query.ATOKEN != undefined && to.query.ATOKEN != ''){
			$common.setItem('ATOKEN',to.query.ATOKEN).then((res)=>{
				$userInfo.getUserInfo().then((res)=>{
					next();
				});
			});
		}else{
			// 已登录
			let _ATOKEN = $common.getItem('ATOKEN');
			if(_ATOKEN != undefined && _ATOKEN != null && _ATOKEN != ''){
//				if (!to.query.v) {
//					let _query = JSON.parse(JSON.stringify(to.query));
//					_query.v = Math.random();
//					next({
//						path: to.path,
//						query: _query
//					});
//				} else {
					next();
//				}
			}else{
				// 未登录
				next("/IndexNew");
			}
		}
	}
})

export default router
